export default __webpack_public_path__ + "static/andys@2x-2e5b32e53d85f024b34a5224b27323cc.png";